import { render, staticRenderFns } from "./detail-participant.vue?vue&type=template&id=cf83145c&"
import script from "./detail-participant.vue?vue&type=script&lang=js&"
export * from "./detail-participant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports